/**
 * Profile-field relations for the settings UI.
 *
 * The field-level parent/child maps are shared with the signup/profile dropdowns
 * (PLT-4170), so they live in one place — re-exported here from
 * `shared/constants/profile-fields.constants` (see that file for the v1-static
 * rationale and the v2 path). The lang-key maps below are settings-UI copy only.
 */
export {
  CHILD_FIELD_BY_FIELD,
  PARENT_FIELD_BY_FIELD,
} from 'shared/constants/profile-fields.constants';

/**
 * Lang keys for the "• N roles" / "• no roles yet" row meta, keyed by the CHILD
 * field being counted.
 */
export const CHILD_COUNT_LANG = {
  role: { some: 'ROLES_COUNT', none: 'NO_ROLES_YET' },
  levelOfTraining: { some: 'LEVELS_COUNT', none: 'NO_LEVELS_YET' },
};

/**
 * Lang keys for a dependent card's title (when a parent is selected) and its
 * empty hint (when none is), keyed by the DEPENDENT field.
 */
export const DEPENDENT_LANG = {
  role: { title: 'ROLE_CARD_TITLE', hint: 'SELECT_PROFESSION_HINT' },
  levelOfTraining: { title: 'LEVEL_CARD_TITLE', hint: 'SELECT_ROLE_HINT' },
};
